document.addEventListener("DOMContentLoaded", function () {
  var swiper = new Swiper(".thumbSwiper", {
    spaceBetween: 10,
    slidesPerView: 4,
    freeMode: true,
    watchSlidesProgress: true,
  });

  var swiper2 = new Swiper(".js-slide-introbox", {
    spaceBetween: 60,
    thumbs: {
      swiper: swiper,
    },
  });
});